/* eslint-disable camelcase */
import { useCallback, useEffect, useMemo, useState } from 'react'
import {
  getCurrentEvents,
  getLabOrderPhases,
  getLatestOrderEvents,
} from '../../../lms/utils'

import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Practitioner, PractitionerRole } from 'fhir/r4'
import { useSingleLabOrder } from '../useSingleLabOrder'
import { startSxpProxy } from '../../../../utils/api'
import {
  ADMIN_PROJECT_ID,
  CLIENT_ID,
  LabIQLocCode,
  LABS_PROJECT_ID,
} from '../../../../utils/constants'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import {
  selectedEditLmsOrder,
  selectedLmsActiveTab,
  setActiveOrderStatus,
  setDmsManualRetry,
  setEditLmsOrderId,
  setLmsActiveTab,
  setLmsDateFilter,
  setLmsOrderId,
  setLmsPatientName,
  setLmsPatientPhone,
  setLmsPreferredCommunication,
} from '../../lmsSlice'
import { TESTING_WRITE, VALIDATION_WRITE } from '../../../../utils/roles'

import {
  optionValue,
  OrderEvent,
  OrderEventTest,
} from '../../../labTests/models'
import {
  emptyString,
  service,
  tabs,
} from '../../../Radiology/Constants/constants'
import {
  intent,
  forms,
  approved,
  unapproved,
  rejected,
  LabMsg,
  LabIntent,
  completed,
  entered,
  validation,
  testing,
  prefix,
  messages,
  formValues,
} from '../../../administration/constants'
import {
  CLabel,
  InvoiceData,
  LabResult,
  LmsValues,
  REJECTED,
  ResultCount,
  SUBMITTED,
  labDepartments,
  testStatus,
  toastOptions,
} from '../../models'
import {
  encodeNewLineText,
  getApplicableRange,
  groupResultsToTests,
  formatInvoiceKeyData,
  makeName,
  mapResults,
  panelFilter,
  panelValidationFilter,
  formatDoctors,
} from '../../utils'
import KeycloakService from '../../../../utils/keycloakService'
import TestGroup from '../TestGroup'
import LoadingButton from '../../../../components/LoadingButton'
import ToastMessage from '../ToastMessage'
import { getAgeInYears, readableDateFormat } from '../../../../utils/dateUtils'
import LabelLogo from '../../../../assets/images/sampleLabelPrint.webp'
import UploadLabs from '../dashboard/UploadLabs'
import LocationByPrefix from '../../../patients/dashboard/LocationByPrefix'
import { NEW_IPD_DATA_UPDATE } from '../../../Notification/Constants'
import { sendSocketData } from '../../../Notification/Socket'
import {
  APPROVED,
  approvedResultsJourney,
  communicationNo,
  communicationYes,
  COMPLETED,
  exceedingResultsForLabTests,
  lmsIntent,
  locationType,
  NONE,
  notificationFailure,
  notificationSent,
  orderStatusRejected,
  reportGenerationFailed,
  submitLabOrderJourney,
  systemResultEnteredBy,
  YES,
  NO,
  WHATSAPP,
  SMS,
  labIq,
  labIqString,
} from '../../constants'
import { useInvoicePDFGenerator } from '../dashboard/InvoicePdfLib'
import {
  updateRetryFlagForLabOrder,
  uploadAndSendNotification,
} from '../../../../services/IPDService'
import { getLocationAddress } from '../../../patients/utils'
import {
  selectLocationById,
  selectLocations,
  selectSelectedLocationId,
} from '../../../location/locationSlice'
import { Backdrop, CircularProgress, Typography, useTheme } from '@mui/material'
import useCustomStyles from '../../../../utils/hooks/CustomStylesHook'
import { radiologyColor } from '../../../Radiology/Utils/RadiologyColors'
import {
  getOrganizationForVendor,
  updatedOrderEvent,
  updateOrderPhases,
} from '../../../../services/LmsService'
import ExceedingResultsDialog from './ExceedingResultsDialog'
import { printLabelPDF } from '../dashboard/PrintLabelPDF'
import { visitDashboardConstants } from '../../../campManagement/constants/Constants'
const styles = () => ({
  centerHeader: {
    color: radiologyColor?.white,
    fontSize: '12px',
    textAlign: 'center',
    background: '#4682b4',
    '& .ag-header-cell-text': {
      flex: 1,
      fontSize: '12px',
      background: '#4682b4',
    },
  },
  referredActions: {
    display: 'flex',
  },
  backdrop: {
    zIndex: 9999,
  },
})
const EnterOrder = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [apiLoading, setApiLoading] = useState(false)
  const [validationLoading, setValidationLoading] = useState(false)
  let updateUiTimeout: NodeJS.Timeout
  const [reload, setReload] = useState(1)
  const { id } = useParams()
  const { order, patient } = useSingleLabOrder(id ?? '', reload)
  const [results, setResults] = useState<LabResult[]>([])
  const [active, setActive] = useState(0)
  const [updated, setUpdated] = useState<Set<number>>(() => new Set())
  const [summary, setSummary] = useState(order?.summary ?? '')
  const [editing, setEditing] = useState(false)
  const [organizations, setOrganizations] = useState<any>([])
  const getData = async () => {
    const response = await getOrganizationForVendor()
    setOrganizations(response?.data?.organization)
  }
  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [totalcount, setTotalCount] = useState<Record<string, ResultCount>>({})
  const [labDepartments, setLabDepartments] = useState<labDepartments[]>([])
  const [reason] = useState('')
  const [checkedTestIds, setCheckedTestIds] = useState<any>([])
  const [checkedTests, setCheckedTests] = useState<LabResult[]>([])
  const [checkedApproveTests, setCheckedApproveTests] = useState<any>([])
  const [checkedApproveIds, setCheckedApproveIds] = useState<any>([])
  // const [checkedPathologists, setCheckedPathologists] = useState<any>([])
  const [allPathologists, setAllPathologists] = useState<any>([])
  const [allReasons, setAllReasons] = useState<any>([])
  const [allChecked, setAllChecked] = useState(false)
  const [allApproveCheck, setAllApproveCheck] = useState(false)
  const [allCheck, setAllCheck] = useState(false)
  const [allApproveChecked, setAllApproveChecked] = useState(false)
  const [check, setCheck] = useState('')
  const [approveCheck, setApproveCheck] = useState('')
  const [testingCount, setTestingCount] = useState(0)
  const [validateCount, setValidateCount] = useState(0)
  const activeTab = useAppSelector(selectedLmsActiveTab)
  const panelLength = panelFilter(order)
  const panelValidateLength = panelValidationFilter(order)
  const [testIds, setTestIds] = useState<number[]>([])
  const [parameterIds, setParameterIds] = useState<number[]>([])
  const editLmsOrder = useAppSelector(selectedEditLmsOrder)
  const [openTest, setOpenTest] = useState(false)
  const { generatePDF } = useInvoicePDFGenerator()
  const locations = useAppSelector(selectLocations)
  const selectedLoc = useAppSelector(selectSelectedLocationId)
  const [submitTests, setSubmitTests] = useState<LabResult[]>([])
  const [dialogOpen, setDialogOpen] = useState(false)
  const [exceedingResults, setExceedingResults] = useState<LabResult[]>([])
  const selcetedLocID = useAppSelector((state) =>
    selectLocationById(selectedLoc, state)
  )
  const location = useAppSelector((state) =>
    selectLocationById(selectedLoc, state)
  )
  const patientUhid = patient?.identifier?.find(
    (id) => id?.system === visitDashboardConstants?.defaults?.patientIdentifier
  )?.value
  const labIqType =
    location?.resource?.type?.[0]?.coding?.find(
      (item: { code?: string; value?: string }) => item?.code === locationType
    )?.display === LabIQLocCode || order?.origin === optionValue?.b2b?.value
      ? true
      : false
  const generateReportBlob = async (order: any): Promise<Blob | undefined> => {
    try {
      const panelIds =
        order?.panels?.flatMap((ip: any) =>
          ip?.lab_tests?.map((ipl: any) => ipl?.id)
        ) ?? []
      const testIds = order?.lab_tests?.map((il: any) => il?.id) ?? []

      const state = {
        orderId: order?.id,
        ids: [...panelIds, ...testIds],
      }

      const fileIdResponse = await startSxpProxy(
        LABS_PROJECT_ID,
        intent?.getDocIdForLabOrder,
        { id: order?.id }
      )
      const fileId = fileIdResponse?.data?.lab_orders_by_pk?.document_id

      const data = await startSxpProxy(
        LABS_PROJECT_ID,
        intent?.getLabTestsByIds,
        state
      )

      const panels = formatInvoiceKeyData(
        data?.data?.lab_test ?? [],
        order?.status ?? '',
        labDepartments
      )
      if (panels?.length === 0) {
        toast.error('No Panels found')
        return undefined
      }

      const prefixIdentifier = selcetedLocID?.resource?.identifier?.find(
        (item: { system?: string; value?: string }) => item?.system === prefix
      )
      const locationAddress = getLocationAddress(
        prefixIdentifier?.value || '',
        locations
      )
      const logoValue =
        CLIENT_ID === labIq || labIqType ? labIqString : emptyString
      const obj: InvoiceData = {
        id: patientUhid ?? order?.patientThopId ?? order?.patient_id ?? '',
        name: makeName(patient?.name),
        patientAddress: locationAddress,
        age: patient?.birthDate ? getAgeInYears(patient?.birthDate) : '',
        gender: patient?.gender,
        mobile: patient?.telecom?.[0]?.value ?? '',
        lrNumber: order?.lr_number ?? '',
        orderType: order?.origin ?? '',
        orderedOn: order?.ordered_on ?? '',
        completedOn: new Date().toISOString() ?? '',
        requestedBy: order?.requested_by ?? order?.ordered_by_name ?? '',
        validatedOn: new Date().toISOString() ?? '',
        panels: panels,
        summary: order?.summary ? order?.summary : '',
        invoiceWithHeaderValue: true,
        pathologySignature: '', // optional if needed
        pathologistName: order?.authorised_by_name,
        fileId: fileId,
        logoValue: logoValue,
      }
      const pdfBlob = await generatePDF(obj)
      return pdfBlob
    } catch (err) {
      console.error(err)
      toast.error(reportGenerationFailed)
      return undefined
    }
  }
  const handleCheckboxChange = (
    testId: number,
    isChecked: boolean,
    tests: LabResult[]
  ) => {
    setCheckedTestIds((prevCheckedTestIds: any) => {
      const updatedCheckedTestIds = isChecked
        ? [...prevCheckedTestIds, testId]
        : prevCheckedTestIds?.filter((id: any) => id !== testId)
      return updatedCheckedTestIds
    })
    setCheckedTests((prev: any) => {
      const updatedCheckedTestIds = isChecked
        ? [...prev, tests]
        : prev?.filter((test: any) => test?.lab_test?.panel?.id !== testId)
      return updatedCheckedTestIds.flat()
    })
    const checking = isChecked ? 'checked' : 'unChecked'
    setCheck(checking)
  }
  useEffect(() => {
    if (check === 'unChecked' && panelLength?.length !== 0) {
      setAllCheck(panelLength?.length === checkedTestIds?.length)
      setCheck('')
    }
    if (check === 'checked' && panelLength?.length !== 0) {
      setAllCheck(panelLength?.length === checkedTestIds?.length)
      setCheck('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [check])
  useEffect(() => {
    if (checkedTestIds?.length === 0) {
      setAllCheck(false)
      setAllChecked(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedTestIds])
  useEffect(() => {
    if (allCheck) {
      setAllChecked(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allCheck])

  const handleCheckboxApproveChange = (
    testId: number,
    isChecked: boolean,
    tests: LabResult[]
  ) => {
    setCheckedApproveIds((prevCheckedTestIds: any) => {
      const updatedCheckedTestIds = isChecked
        ? [...prevCheckedTestIds, testId]
        : prevCheckedTestIds?.filter((id: any) => id !== testId)
      return updatedCheckedTestIds
    })
    setCheckedApproveTests((prev: any) => {
      const updatedCheckedTestIds = isChecked
        ? [...prev, tests]
        : prev?.filter((test: any) => test?.lab_test?.panel?.id !== testId)
      return updatedCheckedTestIds.flat()
    })
    const checking = isChecked ? approved : unapproved
    setApproveCheck(checking)
  }
  useEffect(() => {
    if (approveCheck === unapproved) {
      setAllApproveChecked(
        panelValidateLength?.length === checkedApproveIds?.length
      )
      setApproveCheck('')
    }
    if (approveCheck === approved) {
      setAllApproveChecked(
        panelValidateLength?.length === checkedApproveIds?.length
      )
      setApproveCheck('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [approveCheck])
  useEffect(() => {
    if (checkedApproveIds?.length === 0) {
      setAllApproveChecked(false)
      setAllApproveCheck(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedApproveIds])
  useEffect(() => {
    if (allApproveChecked) {
      setAllApproveCheck(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allApproveChecked])

  const handleAllCheckedChange = (e: any) => {
    const isChecked = e.target.checked
    setAllChecked(isChecked)
    setAllCheck(isChecked)
    setTestingCount((prev) => prev + 1)
  }
  const handleAllApproveChecked = (e: any) => {
    const isChecked = e.target.checked
    setAllApproveCheck(isChecked)
    setAllApproveChecked(isChecked)
    setValidateCount((prev) => prev + 1)
  }
  const filterLabResults = (results: any) => {
    const uniqueResults: any = {}
    results.forEach((result: any) => {
      if (result?.referred_out) {
        const panelId = result.lab_test.panel_id
        if (!uniqueResults[panelId]) {
          uniqueResults[panelId] = result
        }
      }
    })

    return Object.values(uniqueResults)
  }
  const filteredLabResults = order?.lab_results
    ? filterLabResults(order?.lab_results)
    : ''
  useEffect(() => {
    startSxpProxy(ADMIN_PROJECT_ID, intent.getLabInchargeList)
      .then((res) => {
        const practitioners = res?.data?.entry?.filter(
          (e: { resource: { resourceType: string } }) =>
            e.resource?.resourceType === forms.practitioner
        )
        const roles: { resource: PractitionerRole }[] =
          res?.data?.entry?.filter(
            (e: { resource: { resourceType: string } }) =>
              e?.resource?.resourceType === forms?.practitionerRole
          )
        const data = practitioners?.map((e: { resource: Practitioner }) => {
          const firstName =
            e.resource?.name?.[0]?.given?.join(emptyString) ?? emptyString
          const lastName = e.resource?.name?.[0]?.family ?? emptyString
          const signature = e.resource?.photo?.[1]?.url ?? ''
          return {
            id: e.resource?.id,
            name: firstName.concat(' ', lastName),
            signature: signature,
            speciality: formatDoctors(roles, e?.resource?.id) || formValues?.na,
            active: e?.resource?.active,
          }
        })
        setLabDepartments(data)
      })
      .catch((err) => console.error(err))
  }, [reload])

  const updateSet = (i: number) => {
    setUpdated((pr) => new Set(pr).add(i))
  }

  useEffect(() => {
    setSummary(order?.summary ?? '')
  }, [order])

  useEffect(() => {
    if (id) {
      const state = {
        labOrderId: id,
      }
      startSxpProxy(LABS_PROJECT_ID, 'getLabResultByLabOrderId', state)
        .then((data) => {
          const labResults: LabResult[] = data.data.lab_result ?? []
          setResults(labResults)
          setEditing(false)
        })
        .catch(() => {
          setResults([])
        })
    }
  }, [id, reload, order, selcetedLocID?.resource?.name, selectedLoc])

  const getTestIds = useCallback(async () => {
    const newTestIds: number[] = []
    const newParameterIds: number[] = []
    await Promise?.all(
      results?.map(async (result) => {
        if (result?.result_entered_by === systemResultEnteredBy) {
          newParameterIds?.push(result?.lab_test?.id)
          if (!newTestIds?.includes(result?.lab_test?.panel?.id)) {
            newTestIds?.push(result?.lab_test?.panel?.id)
          }
        }
      })
    )
    setTestIds(newTestIds)
    setParameterIds(newParameterIds)
  }, [results])

  useEffect(() => {
    getTestIds()
  }, [results, getTestIds])
  const groupedTests = groupResultsToTests(results)
  const ids = Object.keys(groupedTests).flatMap((ok) => {
    return groupedTests[parseInt(ok)]
      .filter((gt) => gt.test_status !== 'REJECTED')
      .map((gtf) => gtf.id)
  })
  const countResults = async () => {
    const results = await mapResults([id])
    setTotalCount(results)
  }
  useEffect(() => {
    countResults()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])
  const handleReferredOutChange = (val: boolean, index: number) => {
    setResults((r) =>
      r?.map((rs) => {
        if (
          index === rs?.lab_test?.panel?.id &&
          rs?.test_status !== orderStatusRejected
        ) {
          rs.referred_out = !val
          updateSet(rs?.id)
        }
        return rs
      })
    )
  }

  const handleReferredToChange = (val: number, index: number) => {
    setResults((r) =>
      r?.map((rs) => {
        if (
          index === rs?.lab_test?.panel?.id &&
          rs?.test_status !== orderStatusRejected
        ) {
          rs.referred_to = val
          updateSet(rs?.id)
        }
        return rs
      })
    )
  }

  const handleDocUrlChange = (val: string, index: number) => {
    setResults((r) =>
      r?.map((rs) => {
        if (index === rs?.lab_test?.panel?.id && rs?.test_status !== rejected) {
          rs.document_url = val
          updateSet(rs?.id)
        }
        return rs
      })
    )
  }

  const handleValueChange = (val: string, index: number) => {
    setResults((r) =>
      r?.map((rs) => {
        if (rs?.id === index) {
          rs.value = val
        }
        return rs
      })
    )
    updateSet(index)
  }

  const handleExtraValueChange = (val: string, index: number) => {
    setResults((r) =>
      r.map((rs) => {
        if (rs.id === index) {
          rs.extra_value = val
        }
        return rs
      })
    )
    updateSet(index)
  }

  const handleNotesChange = (val: string, index: number) => {
    setResults((r) =>
      r.map((rs) => {
        if (rs.id === index) {
          rs.observation = val
        }
        return rs
      })
    )
    updateSet(index)
  }

  const handleValuesChange = (values: LmsValues, index: number) => {
    setResults((r) =>
      r.map((rs) => {
        if (rs.id === index) {
          rs.values = values
        }
        return rs
      })
    )
    updateSet(index)
  }

  const handleEnter = (testId: number) => {
    const found = ids?.findIndex((i) => i === testId)
    if (found !== -1) {
      setActive(found + 1)
    } else {
      setActive((id) => id + 1)
    }
  }
  const handleDialogOpen = (results: LabResult[]) => {
    setExceedingResults(results)
    setDialogOpen(true)
  }

  const handleDialogClose = () => {
    setDialogOpen(false)
    setExceedingResults([])
    setSubmitTests([])
  }
  const handleSave = useCallback(() => {
    if (!KeycloakService.hasRole([TESTING_WRITE])) {
      return
    }
    for (const result of results) {
      if (result?.referred_out && !result?.referred_to) {
        toast(
          <ToastMessage message='referredTo is mandatory when referred is checked' />,
          { ...toastOptions, type: 'error' }
        )
        return
      }
    }
    setApiLoading(true)
    const now = new Date().toISOString()
    const user = KeycloakService.getUsername()
    const lastEventTests = order?.order_events?.[0]?.tests ?? []
    const updatedTests = results
      ?.filter((rs) => updated?.has(rs.id))
      ?.map((r) => r.lab_test_id)
    const updatedTestSet = new Set(updatedTests)
    const currentEventTests: OrderEventTest[] = [...lastEventTests]
    const latestOrderEvents = getLatestOrderEvents(lastEventTests)
    const stateObj: Partial<OrderEvent> = {
      id: order?.order_events?.[0]?.id,
      updated_by: user,
      updated_at: now,
      tests: getCurrentEvents(
        latestOrderEvents,
        updatedTestSet,
        currentEventTests,
        entered
      ),
    }
    updatedOrderEvent(stateObj)?.then(() => {
      const mapped = results?.map((rs) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { lab_order, lab_test, organization, ...rest } = rs
        const applicableRange = getApplicableRange(
          lab_test?.test_result_limits,
          patient
        )
        const resultUpdated = updated.has(rs.id)
        const updatedResult: Partial<LabResult> = {
          ...rest,
          value: encodeNewLineText(rs.value),
          values: rs.values,
          extra_value: rs.extra_value,
          observation: encodeNewLineText(rs.observation),
          document_url: rs.document_url || undefined,
          result_limit_id: applicableRange?.id,
          referred_out: rs.referred_out,
          referred_to: rs.referred_out ? rs.referred_to : null,
          test_status: resultUpdated ? entered : rs.test_status,
          result_entered_on: resultUpdated ? now : rs.result_entered_on,
          result_entered_by: resultUpdated
            ? KeycloakService.getFullname()
            : rs.result_entered_by,
          result_entered_by_id: resultUpdated
            ? KeycloakService.getSub()
            : rs.result_entered_by_id,
        }
        return { where: { id: { _eq: rs.id } }, _set: updatedResult }
      })
      const intent = LabIntent?.updateLabResults
      const state = {
        results: mapped,
      }
      startSxpProxy(LABS_PROJECT_ID, intent, state)
        .then(() => {
          sendSocketData({
            messageType: NEW_IPD_DATA_UPDATE,
            patientID: patient?.identifier?.[2]?.value,
            patientLocation: '',
            message: '',
          })
          setApiLoading(false)
          setReload((r) => r + 1)
          setUpdated(new Set())
          dispatch(setLmsActiveTab('testing'))
          dispatch(setActiveOrderStatus('current'))
          toast(<ToastMessage message={LabMsg?.LabResultsSaved} />, {
            ...toastOptions,
            type: 'success',
          })
        })
        .catch((err) => {
          console.log(err)
        })
    })
    const phases = getLabOrderPhases(currentEventTests)
    updateOrderPhases(id, phases)
  }, [results, updated, order, patient, id, dispatch])
  const handleSubmitAction = (testResults: LabResult[]) => {
    if (!KeycloakService.hasRole([TESTING_WRITE])) {
      return
    }
    startSxpProxy(LABS_PROJECT_ID, exceedingResultsForLabTests, {
      orderId: id,
      testResults: testResults,
    })
      .then((data: any) => {
        if (data?.data?.length > 0) {
          const ids = new Set(data?.data?.map((item: any) => item?.test_id))
          const tests = testResults.filter((e: any) => ids.has(e?.lab_test?.id))
          handleDialogOpen(tests)
          setSubmitTests(testResults)
        } else {
          handleSubmit(testResults)
        }
      })
      .catch((err) => console.log(err, 'err-'))
  }
  const handleSubmit = useCallback(
    (testResults: LabResult[]) => {
      if (!KeycloakService.hasRole([TESTING_WRITE])) {
        return
      }
      const lastEventTests = order?.order_events?.[0]?.tests ?? []
      const currentEventTests: OrderEventTest[] = [...lastEventTests]
      setApiLoading(true)
      startSxpProxy(LABS_PROJECT_ID, submitLabOrderJourney, {
        order,
        testResults,
        labOrderId: id,
        patient,
      })
        .then(async (data: any) => {
          if (data?.data?.code === 200) {
            sendSocketData({
              messageType: NEW_IPD_DATA_UPDATE,
              patientID: patient?.identifier?.[2]?.value,
              patientLocation: '',
              message: '',
            })
            sendSocketData({
              messageType: NEW_IPD_DATA_UPDATE,
              patientID: patient?.identifier?.[2]?.value,
              patientLocation: '',
              message: '',
            })

            const selectedIds = testResults?.map((tr) => tr?.lab_test_id)
            const latestOrderEvents = getLatestOrderEvents(lastEventTests)
            await getCurrentEvents(
              latestOrderEvents,
              selectedIds,
              currentEventTests,
              SUBMITTED
            )

            const phases = getLabOrderPhases(currentEventTests)
            updateOrderPhases(id, phases)
            setCheckedTestIds([])
            setCheckedTests([])
            setAllChecked(false)
            setApiLoading(false)
            setReload((r) => r + 1)
            dispatch(setActiveOrderStatus('current'))
            toast(<ToastMessage message={LabMsg?.LabResultsSubmitted} />, {
              position: 'bottom-center',
              hideProgressBar: true,
              closeButton: false,
              theme: 'dark',
              autoClose: 2000,
            })
            dispatch(setLmsActiveTab('validation'))
          } else {
            toast.error('Something went wrong')
          }
        })
        .catch((err) => {
          if (err?.response?.data?.errors?.length > 0) {
            err?.response?.data?.errors?.map((e: any) => {
              toast?.error(e)
            })
          } else {
            toast.error(err?.response?.data?.message || 'An Error Occured')
          }
        })
    },
    [order, patient, id, dispatch]
  )

  const handleCancelEdit = (isEdit: boolean) => {
    if (isEdit) {
      setReload((r) => r + 1)
    } else {
      setEditing(true)
    }
  }

  const handleApprove = useCallback(
    (testResults: LabResult[], reason: string, pathologist?: string) => {
      if (!KeycloakService?.hasRole([VALIDATION_WRITE])) {
        return
      }
      setApiLoading(true)
      const now = new Date()?.toISOString()
      const user = KeycloakService?.getUsername()
      const selectedIds = testResults?.map((tr) => tr?.lab_test_id)
      const lastEventTests = order?.order_events?.[0]?.tests ?? []
      const currentEventTests: OrderEventTest[] = [...lastEventTests]
      const latestOrderEvents = getLatestOrderEvents(lastEventTests)
      const pathologistName = labDepartments?.find(
        (e) => e?.id === pathologist
      )?.name
      const stateObj: Partial<OrderEvent> = {
        updated_by: user,
        updated_at: now,
        id: order?.order_events?.[0]?.id,
        tests: getCurrentEvents(
          latestOrderEvents,
          selectedIds,
          currentEventTests,
          APPROVED
        ),
        comments: reason,
        authorised_by_id: pathologist,
        authorised_by_name: pathologistName,
      }
      updatedOrderEvent(stateObj)?.then(() => {
        const intent = lmsIntent?.updateLabOrdersShort
        const updated = {
          status: currentEventTests.every((ct) => ct.status === APPROVED)
            ? COMPLETED
            : SUBMITTED,
          summary: summary,
          validation_completed_on: new Date().toISOString(),
          validated_by_id: KeycloakService.getSub(),
          validated_by_name: KeycloakService.getFullname(),
          authorised_by_id: pathologist,
          authorised_by_name: pathologistName,
          active_phases: getLabOrderPhases(currentEventTests),
          updated_on: new Date().toISOString(),
        }
        const state = {
          order: updated,
          labOrderId: id,
        }
        startSxpProxy(LABS_PROJECT_ID, intent, state)
          .then(() => {
            const mapped = testResults.map((rs) => {
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              const { lab_order, lab_test, organization, ...rest } = rs
              const updatedResult: Partial<LabResult> = {
                ...rest,
                test_status: 'APPROVED',
                validated_on: now,
                validated_by: KeycloakService.getFullname(),
                authorised_by_id: pathologist,
                authorised_by_name: pathologistName,
              }
              if (reason) {
                updatedResult.summary_reason = reason
              }
              return { where: { id: { _eq: rs.id } }, _set: updatedResult }
            })
            startSxpProxy(LABS_PROJECT_ID, 'updateLabResults', {
              results: mapped,
            }).then(() => {
              sendSocketData({
                messageType: NEW_IPD_DATA_UPDATE,
                patientID: patient?.identifier?.[2]?.value,
                patientLocation: '',
                message: '',
              })
              setApiLoading(false)
              setReload((r) => r + 1)
              toast(<ToastMessage message='Lab Order Validated' />, {
                position: 'bottom-center',
                hideProgressBar: true,
                closeButton: false,
                theme: 'dark',
                autoClose: 2000,
              })
              dispatch(setActiveOrderStatus('current'))
              dispatch(setLmsOrderId(order?.id?.toString() ?? ''))
              dispatch(setLmsPatientPhone(patient?.telecom?.[0]?.value ?? ''))
              dispatch(setLmsPatientName(makeName(patient?.name)))
              dispatch(setLmsActiveTab('dispatch'))
              setTimeout(() => {
                navigate('/lms/dashboard')
                if (patient?.telecom?.[3].value === YES) {
                  dispatch(setLmsPreferredCommunication(SMS))
                } else if (patient?.telecom?.[3].value === NO) {
                  dispatch(setLmsPreferredCommunication(WHATSAPP))
                } else {
                  dispatch(setLmsPreferredCommunication(NONE))
                }
              }, 1000)
            })
          })
          .catch((err) => {
            console.error(err)
          })
      })
    },
    [order, labDepartments, summary, patient, id, dispatch, navigate]
  )

  const handleApprovecheck = async (
    testResults: LabResult[],
    reason: string
  ) => {
    if (!KeycloakService.hasRole([VALIDATION_WRITE])) {
      return
    }

    setValidationLoading(true)
    const lastEventTests = order?.order_events?.[0]?.tests ?? []
    const currentEventTests: OrderEventTest[] = [...lastEventTests]
    startSxpProxy(LABS_PROJECT_ID, approvedResultsJourney, {
      order: order,
      labOrderId: id,
      patient: patient,
      testResults: testResults,
      allPathologists,
      labDepartments,
      reason,
      summary,
    })
      .then(async () => {
        sendSocketData({
          messageType: NEW_IPD_DATA_UPDATE,
          patientID: patient?.identifier?.[2]?.value,
          patientLocation: '',
          message: '',
        })

        setReload((r) => r + 1)
        toast(<ToastMessage message={LabMsg?.OrderValidated} />, {
          position: 'bottom-center',
          hideProgressBar: true,
          closeButton: false,
          theme: 'dark',
          autoClose: 2000,
        })

        setCheckedApproveTests([])
        setAllApproveCheck(false)
        dispatch(setActiveOrderStatus('current'))

        if (editLmsOrder) {
          setValidationLoading(false)
          dispatch(setLmsDateFilter(new Date()?.toISOString()?.slice(0, 10)))
          dispatch(setLmsActiveTab('dispatch'))
          dispatch(setEditLmsOrderId(order?.id?.toString() ?? ''))
          navigate('/lms/dashboard')
        } else {
          const isNotYtNaidu =
            order?.source !==
            process.env.REACT_APP_API_YT_NAIDU_OPERATING_UNIT_NAME
          const communicationMode =
            patient?.telecom?.[3]?.value === communicationYes
              ? service?.SMS
              : patient?.telecom?.[3]?.value === communicationNo
              ? service?.WHATSAPP
              : NONE

          if (communicationMode !== NONE) {
            const blobData = await generateReportBlob(order) // ✅ generate blob
            if (blobData) {
              const response = await uploadAndSendNotification(
                id,
                communicationMode,
                patient?.telecom?.[0]?.value ?? '',
                selcetedLocID?.resource?.name ?? '',
                makeName(patient?.name),
                'laborder',
                true,
                blobData, // ✅ attach PDF blob
                selcetedLocID?.resource?.id ?? ''
              )
              if (isNotYtNaidu) {
                if (response?.success) {
                  toast(<ToastMessage message={messages?.notificationSent} />, {
                    position: 'bottom-center',
                    hideProgressBar: true,
                    closeButton: false,
                    theme: 'dark',
                    autoClose: 2000,
                  })
                  toast.success(notificationSent)
                } else {
                  toast(<ToastMessage message={messages?.reportFailed} />, {
                    position: 'bottom-center',
                    hideProgressBar: true,
                    closeButton: false,
                    theme: 'dark',
                    autoClose: 2000,
                  })
                  updateRetryFlagForLabOrder(order?.id ? order?.id : '', true)
                  if (updateUiTimeout) {
                    clearTimeout(updateUiTimeout)
                  }
                  updateUiTimeout = setTimeout(() => {
                    dispatch(setDmsManualRetry())
                  }, 2000)
                }
              }

              setValidationLoading(false)
            } else {
              toast.error(notificationFailure)
              setValidationLoading(false)
            }
            setValidationLoading(false)
          }
        }
      })
      .catch((err) => {
        setValidationLoading(false)
        console.error(err)
      })
    setValidationLoading(false)
    dispatch(setLmsActiveTab('validation'))
    navigate('/lms/dashboard')
    const selectedIds = testResults?.map((tr) => tr?.lab_test_id)
    const latestOrderEvents = getLatestOrderEvents(lastEventTests)
    await getCurrentEvents(
      latestOrderEvents,
      selectedIds,
      currentEventTests,
      APPROVED
    )
    const phases = getLabOrderPhases(currentEventTests)
    await updateOrderPhases(id, phases)
  }

  const handleReject = useCallback(
    (testResults: LabResult[], reason: string) => {
      if (!reason) {
        alert('Select a reason to reject')
        return
      }
      setApiLoading(true)
      const now = new Date().toISOString()
      const user = KeycloakService.getUsername()
      const lastEventTests = order?.order_events?.[0]?.tests ?? []
      const updatedTests = testResults?.map((r) => r?.lab_test_id)
      const currentEventTests: OrderEventTest[] = [...lastEventTests]

      const latestOrderEvents = getLatestOrderEvents(lastEventTests)
      const stateObj: Partial<OrderEvent> = {
        comments: reason,
        updated_by: user,
        updated_at: now,
        id: order?.order_events?.[0]?.id,
        tests: getCurrentEvents(
          latestOrderEvents,
          updatedTests,
          currentEventTests,
          REJECTED
        ),
      }
      updatedOrderEvent(stateObj)?.then(() => {
        const valId = KeycloakService?.getSub()
        const valName = KeycloakService?.getFullname()
        const rejectResults = testResults?.map((rs) => {
          const updatedResult: Partial<LabResult> = {
            test_status: REJECTED,
            rejection_reason: reason,
            rejected_on: now,
            rejected_by_id: valId,
            rejected_by_name: valName,
          }
          return { where: { id: { _eq: rs?.id } }, _set: updatedResult }
        })
        const intent = 'updateLabResults'
        const state = {
          results: rejectResults,
        }
        startSxpProxy(LABS_PROJECT_ID, intent, state)
          .then(() => {
            const updated = {
              status: 'REJECTED',
              active_phases: getLabOrderPhases(currentEventTests),
              updated_on: new Date().toISOString(),
            }
            const newState = {
              order: updated,
              labOrderId: id,
            }
            startSxpProxy(
              LABS_PROJECT_ID,
              lmsIntent?.updateLabOrdersShort,
              newState
            )
              .then(() => {
                sendSocketData({
                  messageType: NEW_IPD_DATA_UPDATE,
                  patientID: patient?.identifier?.[2]?.value,
                  patientLocation: '',
                  message: '',
                })
                setApiLoading(false)
                setReload((r) => r + 1)
                toast(
                  <ToastMessage message='Lab Results Validated [Some Rejected]' />,
                  {
                    position: 'bottom-center',
                    hideProgressBar: true,
                    closeButton: false,
                    theme: 'dark',
                    autoClose: 2000,
                  }
                )
                setTimeout(() => {
                  dispatch(setLmsActiveTab('collection'))
                  navigate('/lms/dashboard')
                }, 1000)
              })
              .catch((err) => {
                console.error(err)
              })
          })
          .catch((err) => {
            console.error(err)
          })
      })
    },
    [order, patient, id, dispatch, navigate]
  )
  const approvedResultsList = async (
    testResults: LabResult[],
    reason: string
  ) => {
    const filter = testResults?.filter((e) => e?.referred_out !== true)
    const filterReferred = testResults?.filter((e) => e?.referred_out)
    const formattedPathologists = allPathologists?.map((e: any) => e?.testId)
    const uniquePathologistsArray = formattedPathologists?.filter(
      (value: any, index: number, self: any) => {
        return self?.indexOf(value) === index
      }
    )
    if (
      uniquePathologistsArray?.length === 0 &&
      filterReferred?.length !== testResults?.length
    ) {
      alert(LabMsg?.SelectPathologists)
      return
    }
    const filteredTest = filter?.every((e: any) =>
      uniquePathologistsArray?.includes(e.lab_test?.panel?.id)
    )
    if (
      filteredTest === false &&
      filterReferred?.length !== testResults?.length
    ) {
      alert(LabMsg?.SelectPathogistsNotReferred)
      return
    }
    await startSxpProxy(LABS_PROJECT_ID, exceedingResultsForLabTests, {
      orderId: id,
      testResults: testResults,
    })
      .then((data: any) => {
        if (data?.data?.length > 0) {
          const ids = new Set(data?.data?.map((item: any) => item?.test_id))
          const tests = testResults?.filter((e: any) =>
            ids?.has(e?.lab_test?.id)
          )
          handleDialogOpen(tests)
          setSubmitTests(testResults)
        } else {
          handleApprovecheck(testResults, reason)
        }
      })
      .catch((err) => console.log(err))
  }
  const handleRejectCheck = useCallback(
    (testResults: LabResult[]) => {
      const formattedReasons = allReasons?.map((e: any) => e?.testId)
      const uniqueReasonsArray = formattedReasons?.filter(
        (value: any, index: number, self: any) => {
          return self?.indexOf(value) === index
        }
      )
      if (uniqueReasonsArray?.length === 0) {
        alert(LabMsg?.RejectMsg)
        return
      }
      const filteredTest = testResults?.every((e: any) =>
        uniqueReasonsArray.includes(e?.lab_test?.panel?.id)
      )
      if (!filteredTest) {
        alert(LabMsg?.SelectPathogistsNotReferred)
        return
      }
      setApiLoading(true)
      const now = new Date().toISOString()
      const user = KeycloakService.getUsername()
      const lastEventTests = order?.order_events?.[0]?.tests ?? []
      const updatedTests = testResults?.map((r) => r?.lab_test_id)
      const currentEventTests: OrderEventTest[] = [...lastEventTests]
      const latestOrderEvents = getLatestOrderEvents(lastEventTests)
      const stateObj: Partial<OrderEvent> = {
        comments: reason,
        updated_by: user,
        updated_at: now,
        id: order?.order_events?.[0]?.id,
        tests: getCurrentEvents(
          latestOrderEvents,
          updatedTests,
          currentEventTests,
          REJECTED
        ),
      }
      updatedOrderEvent(stateObj)?.then(() => {
        const valId = KeycloakService.getSub()
        const valName = KeycloakService.getFullname()
        const rejectResults = testResults?.map((rs) => {
          const { lab_test } = rs
          const updatedResult: Partial<LabResult> = {
            test_status: 'REJECTED',
            rejection_reason: allReasons?.find(
              (e: any) => e?.testId === lab_test?.panel?.id
            )?.reason,
            rejected_on: now,
            rejected_by_id: valId,
            rejected_by_name: valName,
          }
          return { where: { id: { _eq: rs?.id } }, _set: updatedResult }
        })
        const intent = 'updateLabResults'
        const state = {
          results: rejectResults,
        }
        startSxpProxy(LABS_PROJECT_ID, intent, state)
          .then(() => {
            const updated = {
              status: 'REJECTED',
              active_phases: getLabOrderPhases(currentEventTests),
              updated_on: new Date().toISOString(),
            }
            const newState = {
              order: updated,
              labOrderId: id,
            }
            startSxpProxy(
              LABS_PROJECT_ID,
              LabIntent?.updateLabOrdersShort,
              newState
            )
              .then(() => {
                sendSocketData({
                  messageType: NEW_IPD_DATA_UPDATE,
                  patientID: patient?.identifier?.[2]?.value,
                  patientLocation: '',
                  message: '',
                })
                setApiLoading(false)
                dispatch(setActiveOrderStatus('current'))
                setAllReasons([])
                setCheckedApproveTests([])
                setReload((r) => r + 1)
                toast(<ToastMessage message={LabMsg?.ValidatedRejected} />, {
                  position: 'bottom-center',
                  hideProgressBar: true,
                  closeButton: false,
                  theme: 'dark',
                  autoClose: 2000,
                })
                setTimeout(() => {
                  dispatch(setLmsActiveTab('collection'))
                  navigate('/lms/dashboard')
                }, 1000)
              })
              .catch((err) => {
                console.error(err)
              })
          })
          .catch((err) => {
            console.error(err)
          })
      })
    },
    [allReasons, order, patient, id, dispatch, navigate, reason]
  )

  const res = totalcount[id as string]
  const labelOptions = useMemo<CLabel>(
    () => ({
      name: makeName(patient?.name),
      gender: patient?.gender,
      age: patient?.birthDate ? getAgeInYears(patient?.birthDate) : '-',
      patientId: patient?.identifier?.[2]?.value,
      code: order?.lr_number ?? patient?.identifier?.[2]?.value,
    }),
    [
      patient?.name,
      patient?.gender,
      patient?.birthDate,
      patient?.identifier,
      order?.lr_number,
    ]
  )

  const handleLabelPrint = useCallback(() => {
    printLabelPDF(labelOptions)
  }, [labelOptions])
  const handlePathologists = (pathologist: string, id: number) => {
    // const Pathologist = allPathologists?.find((e: any) => e?.testId === id)
    if (pathologist) {
      const dd = allPathologists?.filter((e: any) => e?.testId !== id)
      setAllPathologists([...dd, { testId: id, pathologist }])
    } else {
      setAllPathologists((prev: any) => [...prev, { testId: id, pathologist }])
    }
  }
  const handleReasons = (reason: string, id: number) => {
    if (!reason) {
      setAllReasons((prev: any) => prev?.filter((e: any) => e?.testId !== id))
      return
    }
    const reasons = allReasons?.find((e: any) => e?.testId === id)
    if (reasons) {
      const dd = allReasons?.filter((e: any) => e?.testId !== id)
      setAllReasons([...dd, { testId: id, reason }])
    } else {
      setAllReasons((prev: any) => [...prev, { testId: id, reason }])
    }
  }
  const handleDialogSubmit = async (selectedResults: any[]) => {
    const filteredResults = selectedResults?.filter(
      (result: any) => result?.user_consent || result?.validator_consent
    )

    if (!filteredResults?.length || !submitTests?.length) {
      await handleDialogClose()
      return
    }

    const mergedResults = [...filteredResults, ...submitTests]?.filter(
      (item, index, self) =>
        index === self?.findIndex((t) => t?.id === item?.id)
    )

    try {
      if (activeTab === tabs?.testing) {
        await handleSubmit(mergedResults)
      } else if (activeTab === tabs?.validation) {
        await handleApprovecheck(mergedResults, reason)
      }
    } catch (error) {
      console.error('Dialog submit error:', error)
    } finally {
      await handleDialogClose()
    }
  }

  return (
    <>
      <ExceedingResultsDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        exceedingResults={exceedingResults}
        onSubmit={handleDialogSubmit}
        mode={activeTab === validation ? 'approve' : 'submit'} // Pass mode
      />
      <Backdrop className={classes?.backdrop} open={validationLoading}>
        <Typography variant='h6' color='whitesmoke'>
          Please Wait While Loading----
        </Typography>
        <CircularProgress color='inherit' />
      </Backdrop>
      <div>
        <table className='data-table table-fixed admin-table relative'>
          <thead style={{ position: 'sticky', top: '0px' }}>
            <tr>
              <th className='table-w-5'>Sl No</th>
              <th className='table-w-11'>LR.Number</th>
              <th>UHID</th>
              <th>Name</th>
              <th>Mobile No.</th>
              <th>Operating Unit</th>
              <th className='table-w-5'>Service</th>
              <th className='table-w-10'>Ordered On</th>
              <th className='table-w-6'>Total</th>
              <th className='table-w-6'>Pending</th>
              <th className='table-w-6'>Referred</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>{order?.lr_number}</td>
              <td>{patient?.identifier?.[2]?.value}</td>
              <td>{makeName(patient?.name)}</td>
              <td>{patient?.telecom?.[0]?.value}</td>
              <td>
                <LocationByPrefix
                  id={
                    patient?.identifier?.[2]?.value ??
                    patient?.identifier?.[0]?.value ??
                    '-'
                  }
                />
              </td>
              <td>{order?.origin}</td>
              <td>
                {order?.ordered_on
                  ? readableDateFormat(new Date(order?.ordered_on ?? ''))
                  : '-'}
              </td>
              <td>{res?.total ?? 0}</td>
              <td>{res?.pending ?? 0}</td>
              <td className='collect-content border-none'>
                {res?.referred ?? 0}
                {filteredLabResults.length > 0 && (
                  <UploadLabs docs={filteredLabResults} />
                )}
              </td>
              <td>
                {
                  <>
                    <div className='result-actions'>
                      <button title='Print Label' onClick={handleLabelPrint}>
                        <img
                          src={LabelLogo}
                          alt='Print Label'
                          width={30}
                          height={20}
                        />
                      </button>
                    </div>
                  </>
                }
              </td>
            </tr>
          </tbody>
        </table>
        {order?.id ? (
          results.length > 0 ? (
            <div className='collect-tests'>
              <div className='test-group-container'>
                <p className='admin-header'>Enter Results</p>
                <div className='submitted-container'>
                  {updated.size !== 0 &&
                  !editing &&
                  KeycloakService.hasRole([TESTING_WRITE]) ? (
                    <LoadingButton
                      title='Save'
                      loading={apiLoading}
                      compact
                      onClick={handleSave}
                    />
                  ) : (order?.order_events?.[0]?.tests?.some(
                      (t) => t?.status === entered
                    ) ||
                      results?.some((e) => e?.test_status === entered)) &&
                    activeTab === testing ? (
                    <div className='bed-admin'>
                      <input
                        type='checkbox'
                        checked={allCheck}
                        onChange={handleAllCheckedChange}
                      />
                      <LoadingButton
                        title='Submit'
                        loading={apiLoading}
                        compact
                        disable={checkedTestIds.length === 0}
                        onClick={() => handleSubmitAction(checkedTests)}
                      />
                    </div>
                  ) : null}
                  {order?.order_events?.[0]?.tests?.some(
                    (t) => t.status === testStatus?.submitted
                  ) &&
                    activeTab === validation && (
                      <div>
                        <div className='bed-admin'>
                          <input
                            type='checkbox'
                            checked={allApproveChecked}
                            onChange={handleAllApproveChecked}
                          />
                          <LoadingButton
                            title='Approve'
                            loading={apiLoading}
                            compact
                            disable={checkedApproveTests?.length === 0}
                            onClick={() =>
                              approvedResultsList(checkedApproveTests, reason)
                            }
                          />
                          <LoadingButton
                            title='Reject'
                            loading={apiLoading}
                            compact
                            disable={checkedApproveTests?.length === 0}
                            onClick={() =>
                              handleRejectCheck(checkedApproveTests)
                            }
                          />
                        </div>
                      </div>
                    )}
                </div>
              </div>
              <div>
                <table className='test-group-table w100'>
                  <thead>
                    <tr>
                      <th className='p7 w33'>Test Name</th>
                      <th className='p7 w7'>status</th>
                      <th className='p7 w25'>Actions</th>
                      <th className='p7 w35'>Referred Out</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={4} className='p0'>
                        {Object.keys(groupedTests)?.map((k) => (
                          <div key={k}>
                            <TestGroup
                              key={k}
                              activeId={ids[active]}
                              tests={groupedTests[parseInt(k)]}
                              patient={patient}
                              onReferredOutChange={handleReferredOutChange}
                              onReferredToChange={handleReferredToChange}
                              onDocUrlChange={handleDocUrlChange}
                              onValueChange={handleValueChange}
                              onNotesChange={handleNotesChange}
                              onExtraValueChange={handleExtraValueChange}
                              onValuesChange={handleValuesChange}
                              onEnter={handleEnter}
                              isReferred={false}
                              disabled={order?.status === completed}
                              organizations={organizations}
                              orderStatus={order?.status}
                              valuesUpdated={updated?.size > 0}
                              onSubmit={handleSubmit}
                              onApprove={handleApprove}
                              onReject={handleReject}
                              onEditCancel={handleCancelEdit}
                              apiLoading={apiLoading}
                              labDepartments={labDepartments}
                              onCheckboxChange={handleCheckboxChange}
                              onCheckboxApprove={handleCheckboxApproveChange}
                              allChecked={allChecked}
                              testingCount={testingCount}
                              validateCount={validateCount}
                              allApproveCheck={allApproveCheck}
                              onPathologists={handlePathologists}
                              onReasons={handleReasons}
                              mode={'notReferred'}
                              testIds={testIds}
                              parameterIds={parameterIds}
                              keycloakService={KeycloakService}
                              openTest={openTest}
                              setOpenTest={setOpenTest}
                            />
                          </div>
                        ))}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <p className='all-collected'>No Results found</p>
          )
        ) : (
          <span className='all-collected'>
            Unable to Find Order with the given Id
          </span>
        )}
      </div>
    </>
  )
}

export default EnterOrder
